import { type GridApi } from '@ag-grid-community/core';
import { Card } from '@ics-portal/guardian';
import type { ReactNode } from 'react';
import { useMemo, useState } from 'react';
import { ICSAgGrid } from '@components/ICSGrid/ICSAgGrid';
import { useCardVisibility } from '@hooks/useCardVisibility';
import type { Component } from '@gql/graphql';
import { useDebounce } from '@hooks/useDebounce';
import { ComponentsTableColumns } from '@pages/notification-components/components/ComponentsCard/models/ComponentsTableColumns';
import { getComponentsTableDataSource } from '@pages/notification-components/components/ComponentsCard/utils/getComponentsTableDataSource';

interface ComponentsCardProps {
    selectedChange: (component: Component) => void;
    gridReady: (api: GridApi<Component>) => void;
}

export function ComponentsCard({
    selectedChange,
    gridReady,
}: ComponentsCardProps): ReactNode {
    const cardVisibility = useCardVisibility('notification-components');
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const datasource = useMemo(
        () => getComponentsTableDataSource(debouncedSearchTerm),
        [debouncedSearchTerm],
    );

    return (
        <Card title="Notification components" {...cardVisibility}>
            <ICSAgGrid
                tableDescription="List of all components"
                rowSelection="single"
                columnDefs={ComponentsTableColumns}
                getRowId={(params) => params.data.id}
                onSelectionChanged={(params) => {
                    selectedChange(params.api.getSelectedRows()[0]);
                }}
                onGridReady={(params) => {
                    gridReady(params.api);
                }}
                serverSideDatasource={datasource}
                onGlobalFilterChange={setSearchTerm}
            />
        </Card>
    );
}
